module.exports = __webpack_public_path__ + "img/formula.1a4b023b.png";